module.exports = __webpack_public_path__ + "img/singletrack-study-dashboard.72c01fa7.png";